module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAMCAYAAABvEu28AAAACXBIWXMAAAsSAAALEgHS3X78AAAAsUlEQVQoz62TXQ3DMAyEP1cBUAiFMAiDMAYLpDBoyqAQCmEQCiFDcHtxX6It/dFOshTHp5N9TkwSLZjZDCDp0eIF9tEf4NDxJwRvPwKxqkVJazXmAOSKlyXl4CLJY0PxqFGAuRo3mVkxYHEz7z/MPlJfusa2Fu92y+MmenZrKzACb89HYDotJCmaGcDTryZJ8dI7crGXn9Pe+gtwM7NeUvkilho+9sAAFPyLZEAXI0viA2WQVbjcvXuMAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Download.png
// module id = 135
// module chunks = 0 1